<app-site-grid #SiteGridComponent style="max-width: 350px; width:100%; height: 100%;
overflow-y: auto;" (siteEmit)="loadSiteDetail($event)"></app-site-grid>
<app-site-detail style="width:100%" [siteDetail_]="siteDetail" (siteDetailEmit)="refreshGrid()"></app-site-detail>